import { HeaderTab, HeaderTabItem } from '@vtblife/layout-config/types';
import { RoleType } from '@vtblife/event-bus-events';

import { TabsIds } from './constants';
import { HeaderPersonalButton } from '../types/header.interface';
import { comparePathname } from '../utils/pathname';

export const comparePathnameWithTab = (pathname?: string, item?: HeaderTab | HeaderTabItem): any => {
    return (
        comparePathname(pathname, item) || item?.dropdownMenu?.some((item) => comparePathnameWithTab(pathname, item))
    );
};

export const getActiveTabId = (tabs?: HeaderTab[], pathname?: string) => {
    if (!tabs) {
        return;
    }

    let activeTabId: string = TabsIds.DEFAULT;

    for (const tab of tabs) {
        if (comparePathnameWithTab(pathname, tab)) {
            activeTabId = tab.id;
            break;
        }
    }

    return activeTabId;
};

export const shouldShowPersonalButtons = ({
    currentRoleType,
    pathname,
    items,
}: {
    currentRoleType?: string;
    pathname?: string;
    items?: HeaderTab[];
}): boolean => {
    const activeTabId = getActiveTabId(items, pathname);
    const rolesWithPersonalButtonsSupport = [
        RoleType.Client,
        RoleType.Employee,
        RoleType.Realtor,
        RoleType.Professional,
    ];

    if (
        activeTabId === TabsIds.DEVELOPERS ||
        (currentRoleType && !rolesWithPersonalButtonsSupport.includes(currentRoleType as RoleType))
    ) {
        return false;
    }

    return true;
};

export const getPersonalButtonUrl = (roleType?: string, urls?: HeaderPersonalButton) => {
    if (!urls) return;
    if (!urls.professionalUrl) return urls.url;
    return roleType === 'PROFESSIONAL' || roleType === 'REALTOR' ? urls.professionalUrl : urls.url;
};

export const getOfferPlacementButtonUrl = (isAuthorized?: boolean, urls?: HeaderPersonalButton) => {
    if (!urls) return;
    if (!urls.authorizedUrl) return urls.url;
    return isAuthorized ? urls.authorizedUrl : urls.url;
};

export const isActivePath = (currentPathname?: string, itemPath?: string) => {
    if (!currentPathname || !itemPath) return false;

    const normalizedItemPath = itemPath.startsWith('/') ? itemPath : `/${itemPath}`;

    return (
        currentPathname === normalizedItemPath ||
        currentPathname.endsWith(`${normalizedItemPath}/`) ||
        currentPathname.endsWith(normalizedItemPath)
    );
};

export const getFilteredMenuItems = (items: HeaderTab[], deviceType: 'desktop' | 'mobile'): HeaderTab[] =>
    items
        .filter((item) => item.device?.[deviceType])
        .map((item) => ({
            ...item,
            ...(item.dropdownMenu && {
                dropdownMenu: getFilteredMenuItems(item.dropdownMenu, deviceType),
            }),
        }));
